import React from 'react';
import { useTheme } from 'styled-components';
import { Box, NotificationSuccessIcon } from 'edenred-ui';

import { IOnboardingStep } from '@epi-models/components/IOnboardingStep';

import { StepCircle, StepContainer } from './StepperStep.styles';

const StepperStep = ({
  isDone,
  isActive = false,
  label,
  stepNumber
}: IOnboardingStep) => {
  const theme = useTheme();

  return (
    <StepContainer isActive={isActive} isDone={isDone}>
      {isDone ? (
        <Box display="flex" flexShrink={0}>
          <NotificationSuccessIcon width={32} />
        </Box>
      ) : (
        <StepCircle isActive={isActive}>{stepNumber}</StepCircle>
      )}
      <Box
        pl={1}
        fontSize={theme.sizeMedium}
        fontWeight={isActive && theme.fontSemiBold}
      >
        {label}
      </Box>
    </StepContainer>
  );
};

export default StepperStep;
